import { exact, number, string, any } from 'prop-types';

export const addressType = exact({
  id: number,
  unit: string,
  state: string,
  phone_number: number,
  user_id: string,
  street: string,
  zipcode: string,
  created_on: string,
  deleted_at: any,
  lat: any,
  city: string,
  county: string,
  region: string,
  county_fips: string,
  state_code: any,
  lng: any,
  updated_on: string,
});
